import { AuthState, AuthStatus } from "./types";

export const AUTH_DEFAULT_STATE: AuthState = {
  status: AuthStatus.UNKNOWN,
  requireLogin: process.env.REACT_APP_PERSIST === "cloud"
};
